import { Component } from '@angular/core'
import { TranslocoModule } from '@jsverse/transloco'

@Component({
   selector: 'app-help',
   standalone: true,
   imports: [TranslocoModule],
   templateUrl: './help.component.html',
   styles: ''
})
export class HelpComponent {

}
